import { useEffect, useRef } from "react";

// Soft brand glow that trails the pointer on desktop.
export const CursorGlow = () => {
  const ref = useRef(null);
  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || still) return undefined;
    const el = ref.current;
    let x = window.innerWidth / 2, y = window.innerHeight / 3, tx = x, ty = y, frame;
    const move = (e) => { tx = e.clientX; ty = e.clientY; el.style.opacity = "1"; };
    const tick = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      el.style.transform = `translate3d(${x - 300}px, ${y - 300}px, 0)`;
      frame = requestAnimationFrame(tick);
    };
    window.addEventListener("pointermove", move, { passive: true });
    frame = requestAnimationFrame(tick);
    return () => { window.removeEventListener("pointermove", move); cancelAnimationFrame(frame); };
  }, []);
  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="cursor-glow"
      className="pointer-events-none fixed left-0 top-0 z-[45] h-[600px] w-[600px] rounded-full opacity-0 mix-blend-screen transition-opacity duration-700"
      style={{ background: "radial-gradient(circle, rgba(242,101,49,0.13) 0%, rgba(242,101,49,0.05) 35%, transparent 65%)" }}
    />
  );
};

export const GlowOrb = ({ className = "", strength = "md" }) => (
  <div aria-hidden="true" className={`glow-orb glow-orb-${strength} ${className}`} />
);
